module.exports = __webpack_public_path__ + "static/media/logo-csj-sistemas.aa968b64.png";